import {
  CREATE_DAFTAR_SUCCESS,
  CREATE_DAFTAR_FAIL,
  RETRIEVE_DAFTAR_SUCCESS,
  RETRIEVE_DAFTAR_FAIL,
  UPDATE_DAFTAR_SUCCESS,
  UPDATE_DAFTAR_FAIL,
  DELETE_DAFTAR_SUCCESS,
  DELETE_DAFTAR_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_DAFTAR_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_DAFTAR_SUCCESS:
      return payload;

    case RETRIEVE_DAFTAR_FAIL:
      return [...datas];

    case UPDATE_DAFTAR_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_DAFTAR_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
